import loadable from '@loadable/component';

/**
 * Code-split wrapper for PhoneForm — keeps it (and libphonenumber-js) out of the initial bundle; it
 * renders nothing at first paint. Jest maps `*.loadable` modules to their eager originals (see
 * jest.config.cjs).
 */
export const PhoneForm = loadable(
    /* #__LOADABLE__ */
    () => import('./PhoneForm'),
    {
        resolveComponent: (components) => components.PhoneForm,
        ssr: false,
    }
);
